import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdminSidebar } from './AdminSidebar';
const styles = {
    container: {
        display: 'flex',
        height: '100vh',
        backgroundColor: '#f9fafb',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
    },
    mainArea: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        minWidth: 0,
    },
    content: {
        flex: 1,
        overflowY: 'auto',
    },
};
/**
 * Main admin layout wrapper component
 * Provides consistent structure with sidebar navigation and header
 */
export function AdminLayout({ children, currentPage, onNavigate }) {
    return (_jsxs("div", { style: styles.container, children: [_jsx(AdminSidebar, { currentPage: currentPage, onNavigate: onNavigate }), _jsx("div", { style: styles.mainArea, children: _jsx("main", { style: styles.content, children: children }) })] }));
}
